import Link from 'next/link'
import { Avatar, AvatarFallback, AvatarImage } from '~/src/components/ui/avatar'
import useUserData from '~/src/hooks/useUserData'
import useAuthUser from '~/src/hooks/useAuthUser'

interface UserInitialsProps {
  avatarImage?: string
}

const UserInitials = ({ avatarImage }: UserInitialsProps) => {
  const { initials } = useUserData()
  const { authUser } = useAuthUser()

  // Use provided avatar image, then auth user photo URL (if from Google), then fallback to initials
  const imageUrl =
    avatarImage ||
    (authUser?.photoURL && authUser.photoURL.includes('googleusercontent.com')
      ? authUser.photoURL
      : null)

  if (!initials && !imageUrl) return null

  return (
    <Link href='/profile'>
      <Avatar className='h-8 w-8 md:h-9 md:w-9'>
        {imageUrl && <AvatarImage src={imageUrl} alt='User avatar' />}
        <AvatarFallback className='text-sm font-medium'>
          {initials}
        </AvatarFallback>
      </Avatar>
    </Link>
  )
}

export default UserInitials
